import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartStep1Repository } from '@/core/domain/cart-step1/repositories/cart-step1.repository';
import { sendCartStep1UseCase } from '@/core/domain/cart-step1/usecases/sendCartStep1.usecase';
import { CartStep1ImplRepository } from './cart-step1-impl.repository';

const sendCartStep1UseCaseFactory = (
    cartStep1Repository: CartStep1Repository,
) => new sendCartStep1UseCase(cartStep1Repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: sendCartStep1UseCase,
            useFactory: sendCartStep1UseCaseFactory,
            deps: [CartStep1Repository],
        },
        {
            provide: CartStep1Repository,
            useClass: CartStep1ImplRepository,
        },
    ],
})
export class CartStep1DataModule {}
